import DelightLogo from "../../assets/images/delight-logo.png";
import "./Privacy.css";

const LAST_UPDATED = "18 November 2025";
const APP_NAME = "Flirtolo";
const CONTACT_EMAIL = "sanduntharakag1@gmail.com";

export default function Privacy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <img src={DelightLogo} alt="Flirtolo Logo" className="privacy-logo" />
          <h1 className="privacy-title">{APP_NAME} – Privacy Policy</h1>
        </div>
        {/* Title & meta */}
        <p className="privacy-meta">Last updated: {LAST_UPDATED}</p>

        <p className="privacy-intro">
          <strong>{APP_NAME}</strong> is a modern dating and social discovery
          app developed and maintained by <strong>Lankovate</strong>. This
          policy explains how we collect, use, protect, and process your
          personal data.
        </p>

        <p className="privacy-paragraph">
          {APP_NAME} (“we”, “our”, “us”) is a dating and social discovery mobile
          application designed for users in Sri Lanka. We respect your privacy
          and are committed to protecting your personal data. This Privacy
          Policy explains what data we collect, how we use it, how we store it,
          and what rights you have.
        </p>

        <p className="privacy-paragraph">
          If you have any questions, you can contact us at:{" "}
          <a className="privacy-link" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
        </p>

        {/* 1. What Data We Collect */}
        <h2 className="privacy-section-title">1. What Data We Collect</h2>
        <p className="privacy-paragraph">
          We collect only the information needed to create a safe and
          functioning dating platform.
        </p>

        <h3 className="privacy-subsection-title">1.1. Profile Information</h3>
        <p className="privacy-paragraph">
          When you create or update your profile, we collect data given by you:
        </p>

        <h3 className="privacy-subsection-title">1.2. Location Data</h3>
        <p className="privacy-paragraph">
          If you enable location access, we collect:
        </p>
        <ul className="privacy-list">
          <li>
            Automatically generated earth_coord for distance-based matching
          </li>
        </ul>
        <p className="privacy-paragraph">
          We use this only to show you nearby profiles. You can disable location
          sharing anytime through your device settings.
        </p>

        <h3 className="privacy-subsection-title">1.3. Account Information</h3>
        <p className="privacy-paragraph">
          From the authentication system, we collect:
        </p>
        <ul className="privacy-list">
          <li>Email</li>
        </ul>

        <h3 className="privacy-subsection-title">
          1.4. Subscription &amp; Payments (PayHere)
        </h3>
        <p className="privacy-paragraph">
          If you purchase a subscription, we process payments securely through
          PayHere, a Sri Lanka-based payment gateway. We do not store any
          credit/debit card numbers in our database.
        </p>
        <p className="privacy-paragraph">PayHere may collect:</p>
        <ul className="privacy-list">
          <li>Card details</li>
          <li>Billing information</li>
          <li>Payment confirmation details</li>
        </ul>
        <p className="privacy-paragraph">
          All sensitive payment information is handled directly by PayHere
          according to their policies.
        </p>

        <h3 className="privacy-subsection-title">1.5. Messages</h3>
        <p className="privacy-paragraph">
          Messages exchanged between users are encrypted (end-to-end or at
          rest), stored securely, and are not visible to our team unless
          required for legal reasons. We store messages only so that chat works
          between matched users.
        </p>

        <h3 className="privacy-subsection-title">
          1.6. Technical &amp; Device Information
        </h3>
        <p className="privacy-paragraph">
          We automatically collect some technical data, such as:
        </p>
        <ul className="privacy-list">
          <li>Device ID</li>
          <li>Device type (Android/iOS)</li>
          <li>OS version</li>
          <li>App version</li>
          <li>IP address</li>
          <li>Push notification token</li>
          <li>Usage logs (for debugging &amp; analytics)</li>
        </ul>

        {/* 2. Why We Collect Data */}
        <h2 className="privacy-section-title">2. Why We Collect Data</h2>
        <p className="privacy-paragraph">We use your data to:</p>
        <ul className="privacy-list">
          <li>✔ Create &amp; manage user accounts</li>
          <li>✔ Show matches based on preferences &amp; location</li>
          <li>✔ Allow messaging and interaction between users</li>
          <li>✔ Improve accuracy of recommendations</li>
          <li>✔ Maintain app security &amp; prevent fraud/spam</li>
          <li>✔ Enable premium subscription features</li>
          <li>✔ Process payments securely</li>
          <li>✔ Show relevant content and improve user experience</li>
        </ul>
        <p className="privacy-paragraph">We do not sell personal data.</p>

        {/* 3. Storage & Protection */}
        <h2 className="privacy-section-title">
          3. How We Store &amp; Protect Your Data
        </h2>
        <p className="privacy-paragraph">Your data is stored securely using:</p>
        <ul className="privacy-list">
          <li>Managed database with regular backups</li>
          <li>Encrypted storage for sensitive fields</li>
          <li>HTTPS for all communication</li>
          <li>Access control and Row Level Security (RLS)</li>
          <li>Industry-standard authentication</li>
        </ul>
        <p className="privacy-paragraph">
          However, no system is 100% secure. We take reasonable steps to protect
          your information, but we cannot guarantee absolute security.
        </p>

        {/* 4. Sharing */}
        <h2 className="privacy-section-title">
          4. Who We Share Your Data With
        </h2>
        <p className="privacy-paragraph">
          We only share data with service providers necessary to operate the
          app:
        </p>

        <h3 className="privacy-subsection-title">4.1. Database</h3>
        <p className="privacy-paragraph">
          Used for authentication, storage, and security.
        </p>

        <h3 className="privacy-subsection-title">4.2. PayHere</h3>
        <p className="privacy-paragraph">
          Used to process payments securely. We never receive or store your card
          number.
        </p>

        <h3 className="privacy-subsection-title">
          4.3. Analytics &amp; Crash Tools
        </h3>
        <p className="privacy-paragraph">
          We may use tools such as Expo services, Sentry, or Google Analytics to
          monitor app performance and crashes.
        </p>

        <h3 className="privacy-subsection-title">4.4. Law Enforcement</h3>
        <p className="privacy-paragraph">
          We may share data when legally required or to ensure user safety.
        </p>

        <p className="privacy-paragraph">
          We never sell, rent, or trade your data.
        </p>

        {/* 5. Retention */}
        <h2 className="privacy-section-title">5. Data Retention</h2>
        <p className="privacy-paragraph">
          We delete or anonymize your data when it is no longer needed.
        </p>
        <p className="privacy-paragraph">
          Your profile remains active while your account is active. When you
          delete your account:
        </p>
        <ul className="privacy-list">
          <li>Your profile data and images are permanently deleted.</li>
          <li>Messages may be anonymized for safety investigation.</li>
          <li>
            Payments remain stored in PayHere according to banking regulations.
          </li>
        </ul>

        {/* 6. Your Rights */}
        <h2 className="privacy-section-title">6. Your Rights</h2>
        <p className="privacy-paragraph">You have the right to:</p>
        <ul className="privacy-list">
          <li>Access your personal data</li>
          <li>Update or correct your profile information</li>
          <li>Delete your account anytime</li>
          <li>Request deletion of all personal data</li>
          <li>Disable location access</li>
          <li>Withdraw consent for processing where applicable</li>
        </ul>
        <p className="privacy-paragraph">
          To exercise any rights, contact us at{" "}
          <a className="privacy-link" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>

        {/* 7. Children */}
        <h2 className="privacy-section-title">7. Children’s Privacy</h2>
        <p className="privacy-paragraph">
          This app is strictly for adults (18+). We do not knowingly collect
          data from anyone under 18. If we discover such an account, we delete
          it immediately.
        </p>

        {/* 8. International Transfers */}
        <h2 className="privacy-section-title">
          8. International Data Transfers
        </h2>
        <p className="privacy-paragraph">
          Stores data in secure data centers located in several regions. By
          using the app, you consent to this international data transfer.
        </p>

        {/* 9. Changes */}
        <h2 className="privacy-section-title">
          9. Changes to This Privacy Policy
        </h2>
        <p className="privacy-paragraph">
          We may update this policy occasionally. If we make significant
          changes, we will notify you inside the app or update this page.
        </p>

        {/* 10. Contact */}
        <h2 className="privacy-section-title">10. Contact Us</h2>
        <p className="privacy-paragraph">
          If you have questions or concerns regarding this Privacy Policy, reach
          us at:
        </p>
        <p className="privacy-paragraph">
          📧{" "}
          <a className="privacy-link" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
}
